/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { IColumn } from 'types'
import { Button, Tooltip } from '@mui/material'
import { actionIcon, eyeIcon} from 'utils/customizedTheme'
import { FaEye } from 'react-icons/fa'
import { useNavigate } from 'react-router-dom'

export const useTableModel = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const handleActionsFormat = useCallback(
    (cellValue: string, row: any) => <Tooltip title={`${t('common.view')}`} arrow placement='top'>
      <Button
        onClick={() => navigate(`/group-courses/view/${row.id}`)}
        variant='outlined'
        color='primary'
        disableElevation
        sx={{ ...actionIcon, ...eyeIcon }}
      >
        <FaEye />
      </Button>
    </Tooltip>,
    [],
  )

  const handleStatusFormat = useCallback(
      (cellValue: string) => (cellValue ? t(`group-course-statuses.${cellValue}`) : ''),
      [],
  )

  const columns: IColumn[] = [

    {
      title: `${t('common.status')}`,
      field: 'status',
      order: true,
      width: '15%',
      format: handleStatusFormat
    },
    {
      title: `${t('common.group')}`,
      field: 'group',
      order: true,
      width: '15%',
    },
    {
      title: `${t('common.course')}`,
      field: 'course',
      order: true,
      width: '35%',
    },
    {
      title: `${t('school.academic-period')}`,
      field: 'academic_periods',
      order: true,
      width: '25%',
    },
    {
      title: '',
      field: '',
      width: '10%',
      align: 'end',
      order: false,
      format: handleActionsFormat,
    },
  ]

  return columns
}